import { c as _c } from "react/compiler-runtime";
import { ActionMenu, ActionMenuItem } from '@systemeio/ui';
import { nonDraggableProps } from 'modules/courses/courses/curriculum/utils/non-draggable-props';
import React, { memo, useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from '@systemeio/util';
import { KeyedMutator } from 'swr';
import { ModuleId } from '../../curriculum/types/module-interface';
import { useLightCourseActions } from '../hooks/use-light-course-actions';
import { LightCourseCurriculumInterface } from '../light-course-interface';
export interface LectureActionsProps {
  moduleId: ModuleId;
  lecture: LightCourseCurriculumInterface['modules'][number]['lectures'][number];
  mutate: KeyedMutator<LightCourseCurriculumInterface>;
  onEdit: () => void;
}
export const LightCourseLectureActions = memo(function LightCourseLectureActions(t0) {
  const $ = _c(77);
  const {
    lecture,
    moduleId,
    mutate,
    onEdit
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    deleteLightCourseLecture,
    activateLightCourseLecture
  } = useLightCourseActions();
  const {
    revalidateModules
  } = useRevalidateModules();
  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activateLightCourseLecture || $[1] !== deleteLightCourseLecture || $[2] !== isActivateOpen || $[3] !== isRemoveOpen || $[4] !== lecture.active || $[5] !== lecture.id || $[6] !== moduleId || $[7] !== mutate || $[8] !== onEdit || $[9] !== revalidateModules || $[10] !== t) {
    const caption = t("dashboard.course.lecture_title").toLowerCase();
    const lectureId = lecture.id;
    let t10;
    if ($[21] !== activateLightCourseLecture || $[22] !== lecture.active || $[23] !== lecture.id || $[24] !== lectureId || $[25] !== moduleId || $[26] !== mutate) {
      t10 = async () => {
        const update = lecture.active ? "deactivate" : "activate";
        await activateLightCourseLecture(update, lecture.id);
        await mutate(data => {
          if (data) {
            return {
              ...data,
              modules: data.modules.map(module => {
                if (module.id === moduleId) {
                  return {
                    ...module,
                    lectures: module.lectures.map(lecture_0 => {
                      if (lecture_0.id === lectureId) {
                        return {
                          ...lecture_0,
                          active: !lecture_0.active
                        };
                      }
                      return lecture_0;
                    })
                  };
                }
                return module;
              })
            };
          }
        }, false);
      };
      $[21] = activateLightCourseLecture;
      $[22] = lecture.active;
      $[23] = lecture.id;
      $[24] = lectureId;
      $[25] = moduleId;
      $[26] = mutate;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    const handleActivateLecture = t10;
    let t11;
    if ($[28] !== deleteLightCourseLecture || $[29] !== lectureId || $[30] !== moduleId || $[31] !== mutate || $[32] !== revalidateModules) {
      t11 = async () => {
        await deleteLightCourseLecture(lectureId);
        await mutate(data_0 => {
          if (data_0) {
            return {
              ...data_0,
              modules: data_0.modules.map(module_0 => {
                if (module_0.id === moduleId) {
                  return {
                    ...module_0,
                    lectures: module_0.lectures.filter(lecture_1 => lecture_1.id !== lectureId)
                  };
                }
                return module_0;
              })
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.MembershipCourseLecture]);
      };
      $[28] = deleteLightCourseLecture;
      $[29] = lectureId;
      $[30] = moduleId;
      $[31] = mutate;
      $[32] = revalidateModules;
      $[33] = t11;
    } else {
      t11 = $[33];
    }
    const handleRemoveLecture = t11;
    t9 = "flex items-center justify-end";
    t6 = nonDraggableProps;
    let t12;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = {
        "data-test": "module-lecture-actions"
      };
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t13;
    if ($[35] !== lecture.active || $[36] !== t) {
      t13 = lecture.active ? t("dashboard.actions.title.deactivate") : t("dashboard.actions.title.activate");
      $[35] = lecture.active;
      $[36] = t;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    let t14;
    let t15;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = () => {
        setIsActivateOpen(true);
      };
      t15 = {
        "data-test": "module-lecture-action-status"
      };
      $[38] = t14;
      $[39] = t15;
    } else {
      t14 = $[38];
      t15 = $[39];
    }
    let t16;
    if ($[40] !== t13) {
      t16 = <ActionMenuItem key="action-activate" label={t13} onClick={t14} dataTestAttributes={t15} />;
      $[40] = t13;
      $[41] = t16;
    } else {
      t16 = $[41];
    }
    let t17;
    if ($[42] !== t) {
      t17 = t("dashboard.actions.title.settings");
      $[42] = t;
      $[43] = t17;
    } else {
      t17 = $[43];
    }
    let t18;
    if ($[44] !== onEdit) {
      t18 = () => onEdit();
      $[44] = onEdit;
      $[45] = t18;
    } else {
      t18 = $[45];
    }
    let t19;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = {
        "data-test": "module-lecture-action-edit"
      };
      $[46] = t19;
    } else {
      t19 = $[46];
    }
    let t20;
    if ($[47] !== t17 || $[48] !== t18) {
      t20 = <ActionMenuItem key="action-edit" label={t17} onClick={t18} dataTestAttributes={t19} />;
      $[47] = t17;
      $[48] = t18;
      $[49] = t20;
    } else {
      t20 = $[49];
    }
    let t21;
    if ($[50] !== t) {
      t21 = t("dashboard.actions.title.remove");
      $[50] = t;
      $[51] = t21;
    } else {
      t21 = $[51];
    }
    let t22;
    let t23;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = () => {
        setIsRemoveOpen(true);
      };
      t23 = {
        "data-test": "module-lecture-action-remove"
      };
      $[52] = t22;
      $[53] = t23;
    } else {
      t22 = $[52];
      t23 = $[53];
    }
    let t24;
    if ($[54] !== t21) {
      t24 = <ActionMenuItem key="action-remove" label={t21} onClick={t22} dataTestAttributes={t23} />;
      $[54] = t21;
      $[55] = t24;
    } else {
      t24 = $[55];
    }
    if ($[56] !== t16 || $[57] !== t20 || $[58] !== t24) {
      t7 = <ActionMenu dataTestAttributes={t12} menuItems={[t16, t20, t24]} />;
      $[56] = t16;
      $[57] = t20;
      $[58] = t24;
      $[59] = t7;
    } else {
      t7 = $[59];
    }
    let t25;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = () => setIsRemoveOpen(false);
      $[60] = t25;
    } else {
      t25 = $[60];
    }
    t8 = <Confirmation opened={isRemoveOpen} onClose={t25} onConfirm={handleRemoveLecture} confirmationText={t("dashboard.actions.remove_confirmation", {
      module: caption?.toLowerCase()
    })} toastCaption={t("dashboard.actions.removed", {
      module: caption
    })} />;
    T0 = Confirmation;
    t1 = isActivateOpen;
    if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = () => setIsActivateOpen(false);
      $[61] = t2;
    } else {
      t2 = $[61];
    }
    t3 = handleActivateLecture;
    t4 = t("dashboard.actions.activate_confirmation", {
      activate: lecture.active ? t("global.deactivate").toLowerCase() : t("global.activate").toLowerCase(),
      module: caption?.toLowerCase()
    });
    t5 = t("dashboard.actions.activated", {
      module: caption,
      activated: lecture.active ? t("dashboard.actions.deactivated_caption").toLowerCase() : t("dashboard.actions.activated_caption").toLowerCase()
    });
    $[0] = activateLightCourseLecture;
    $[1] = deleteLightCourseLecture;
    $[2] = isActivateOpen;
    $[3] = isRemoveOpen;
    $[4] = lecture.active;
    $[5] = lecture.id;
    $[6] = moduleId;
    $[7] = mutate;
    $[8] = onEdit;
    $[9] = revalidateModules;
    $[10] = t;
    $[11] = T0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[62] !== T0 || $[63] !== t1 || $[64] !== t2 || $[65] !== t3 || $[66] !== t4 || $[67] !== t5) {
    t10 = <T0 opened={t1} onClose={t2} onConfirm={t3} confirmationText={t4} toastCaption={t5} />;
    $[62] = T0;
    $[63] = t1;
    $[64] = t2;
    $[65] = t3;
    $[66] = t4;
    $[67] = t5;
    $[68] = t10;
  } else {
    t10 = $[68];
  }
  let t11;
  if ($[69] !== t10 || $[70] !== t6 || $[71] !== t7 || $[72] !== t8) {
    t11 = <div {...t6}>{t7}{t8}{t10}</div>;
    $[69] = t10;
    $[70] = t6;
    $[71] = t7;
    $[72] = t8;
    $[73] = t11;
  } else {
    t11 = $[73];
  }
  let t12;
  if ($[74] !== t11 || $[75] !== t9) {
    t12 = <div className={t9}>{t11}</div>;
    $[74] = t11;
    $[75] = t9;
    $[76] = t12;
  } else {
    t12 = $[76];
  }
  return t12;
});